import { render, staticRenderFns } from "./ScoreComparisonLoader.vue?vue&type=template&id=c2f1c50a"
import script from "./ScoreComparisonLoader.vue?vue&type=script&lang=js"
export * from "./ScoreComparisonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports